import { Button, Modal } from 'semantic-ui-react';
import styled from '@emotion/styled';
import { clickableStyles } from 'src/components/helpers';
import { screenSizes } from 'src/assets/styles/Literals';

const PaymentInfoModalContainer = styled.div`
  .payment-info-container {
    width: 100%;
    overflow-x: auto;

    .payment-info-table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 16px;
      background: #f8f9fa;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

      th {
        background: #4a90e2;
        color: white;
        padding: 16px;
        text-align: left;
        font-weight: 600;
        font-size: 16px;
      }

      td {
        padding: 16px;
        border-bottom: 1px solid #e9ecef;
        vertical-align: top;
      }

      tbody tr:last-child td {
        border-bottom: none;
      }

      tbody tr:hover {
        background-color: #f1f3f5;
      }

      .payment-method {
        width: 35%;
        background-color: #e3f2fd;
        font-weight: 500;
        color: #1976d2;
      }

      .payment-details {
        width: 65%;
        line-height: 1.5;
        color: #495057;
      }

      @media (max-width: ${screenSizes.tablet}) {
        font-size: 14px;

        th,
        td {
          padding: 12px;
        }

        .payment-method {
          width: 40%;
        }

        .payment-details {
          width: 60%;
        }
      }
    }
  }
`;

const PaymentInfoModal = ({ setPaymentInfoModalOpen, open }) => {
  const handleClose = () => {
    setPaymentInfoModalOpen(false);
  };
  return (
    <>
      <span style={{ ...clickableStyles }} onClick={() => setPaymentInfoModalOpen(true)}>
        Haz clic aquí para saber cómo reportar tu contribución según el canal.
      </span>
      <Modal open={open} onClose={handleClose} size="large" className="payment-info-modal">
        <Modal.Header>Cómo reportar tu contribución según el canal</Modal.Header>
        <Modal.Content>
          <PaymentInfoModalContainer>
            <div className="payment-info-container">
              <table className="payment-info-table">
                <thead>
                  <tr>
                    <th>Medio de Pago</th>
                    <th>Datos y reporte</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="payment-method">
                      <strong>Sobres en efectivo y sobres con datáfono</strong>
                    </td>
                    <td className="payment-details">
                      Ingresa tus datos completos y legibles: nombres, apellidos, tipo y número de
                      documento, valor de la donación, concepto y firma. Marca la casilla "Requiere
                      certificado" si lo necesitas.
                    </td>
                  </tr>
                  <tr>
                    <td className="payment-method">
                      <strong>PSE y PayU</strong>
                    </td>
                    <td className="payment-details">
                      Ingresa los datos completos que se solicitan en la web: nombres, apellidos,
                      tipo y número de documento, valor de la donación, concepto y firma. Marca la
                      casilla "Requiere certificado" si lo necesitas.
                    </td>
                  </tr>
                  <tr>
                    <td className="payment-method">
                      <strong>Consignaciones, transferencias bancarias o QR</strong>
                    </td>
                    <td className="payment-details">
                      Envía tus datos completos: nombres, apellidos, tipo y número de documento, y
                      concepto de la donación al{' '}
                      <a
                        href="https://wa.me/573002658445"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ ...clickableStyles }}
                      >
                        WhatsApp 300 265 8445
                      </a>{' '}
                      o al correo{' '}
                      <a href="mailto:tesoreria@comunidadmde.com" style={{ ...clickableStyles }}>
                        tesoreria@comunidadmde.com
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </PaymentInfoModalContainer>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={handleClose}>Cerrar</Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default PaymentInfoModal;
